// extracted by mini-css-extract-plugin
export default {"image":"style_image__SeD2b","Cameraupload":"style_Cameraupload__B0cag"};